const bgColor1 = [
    "rgba(255, 147, 100, 1)",
    "rgba(255, 147, 100, 1)",
    "rgba(255, 147, 100, 1)",
    "rgba(255, 147, 100, 1)",
    "rgba(255, 147, 100, 1)",
    "rgba(255, 147, 100, 1)",
    "rgba(255, 147, 100, 1)"
];
const bgColor2 = [
    "rgba(76, 196, 228, 1)",
    "rgba(76, 196, 228, 1)",
    "rgba(76, 196, 228, 1)",
    "rgba(76, 196, 228, 1)",
    "rgba(76, 196, 228, 1)",
    "rgba(76, 196, 228, 1)",
    "rgba(76, 196, 228, 1)"
];
// const borderColors = [
//     '#36495d',
//     '#36495d',
//     '#36495d',
//     '#36495d',
//     '#36495d',
//     '#36495d',
//     '#36495d',
//     '#36495d',
//   ]
export const planetChartData = {
    type: "bar",
    data: {
        labels: ["Aug 1", "Aug 2", "Aug 3", "Aug 4", "Aug 5", "Aug 6", "Aug 7"],
        datasets: [
            {
                // one line graph
                label: "Sales",
                data: [5000, 1000, 2000, 6200, 2700, 1400, 2300],
                backgroundColor: bgColor1
            },
            {
                // another line graph
                label: "Revenue",
                data: [4800, 5800, 1390, 1160, 5000, 4900, 3200],
                backgroundColor: bgColor2
            }
        ]
    },
    options: {
        legend: {
            display: false
        },
        responsive: true,
        lineTension: 1,
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                        padding: 25
                    }
                }
            ]
        }
    }
};

export default planetChartData;
